/**
 * @param {object} Drupal - The Drupal object.
 * @param {Function} once - The once function.
 * @param {Array} dataLayer - The GTM dataLayer array.
 */
(function (Drupal, once, dataLayer) {
  'use strict';

  Drupal.behaviors.newsletterModalBehavior = {
    attach: function (context, settings) {
      const MODAL_ID = 'newsletter-signup-modal';

      // Open modal
      once('modal-open-handler', `[href='#${MODAL_ID}']`, context).forEach(
        cta => {
          cta.addEventListener('click', (event) => {
            event.preventDefault();
            const modalElement = document.getElementById(MODAL_ID);
            if (modalElement) {
              modalElement.showModal();
              Drupal.attachBehaviors(modalElement);
              observeFormSubmission(modalElement);
            }
            return false;
          });
        }
      );

      // Helper function to reset the form plus clean UI states/messages.
      function resetModalForm(modalEl) {
        const form = modalEl.querySelector('form');
        if (form) {
          // Reset built-in browser state
          form.reset();

          // Clear text/textarea values
          // Restore defaults instead of empty
          form.querySelectorAll('input:not([type="hidden"],[type="button"],[type="submit"],[type="reset"]), textarea, select').forEach(el => {
            el.value = '';
            el.removeAttribute('aria-invalid');
          });

          // Remove Drupal error classes/icons
          form.querySelectorAll('.error, .is-invalid').forEach(el => {
            el.classList.remove('error', 'is-invalid');
          });

          // Remove any inline error messages
          form.querySelectorAll('.form-item--error-message, .messages, .form-error').forEach(el => {
            el.remove();
          });

          // Clear Drupal error messages
          const msgs = modalEl.querySelector('div[role="alert"], div[data-drupal-messages]');
          if (msgs) {
            msgs.innerHTML = '';
          }
        }
      }

      // Central close function
      function closeModal(modalEl) {
        resetModalForm(modalEl);
        modalEl.close();
      }

      // Close button
      once('modal-close-handler', `#${MODAL_ID} .modal-close`, context).forEach(btn => {
        btn.addEventListener('click', () => {
          const parent = btn.closest('dialog');
          if (parent) {
            closeModal(parent);
          }
        });
      });

      // Backdrop/outside click close
      once('modal-overlay-handler', `#${MODAL_ID}`, context).forEach(dialog => {
        dialog.addEventListener('click', (event) => {
          if (dialog === event.target) {
            closeModal(dialog);
          }
        });
      });

      // Reset on any close
      once('modal-auto-reset', `#${MODAL_ID}`, context).forEach(dialog => {
        dialog.addEventListener('close', () => {
          resetModalForm(dialog);
        });
      });

      // Close modal on outside click - Thank you modal
      document.addEventListener('click', function (event) {
        const modal = document.querySelector('.ui-dialog[aria-modal="true"]');

        if (!modal) {
          return;
        }

        const content = modal.querySelector('.ui-dialog-content');
        if (content && !content.contains(event.target)) {
          const closeButton = modal.querySelector('.ui-dialog-titlebar-close');
          if (closeButton) {
            closeButton.click();
          }
        }
      });

      // Observe success message to auto-close
      function observeFormSubmission(modalElement) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (
              mutation.addedNodes.length > 0 &&
              modalElement.querySelector('.webform-confirmation-modal')
            ) {
              const form = modalElement.querySelector('form');

              if (form) {
                dataLayer.push({
                  'event': 'enewsletter_sign_up',
                  'data-analytics-id': form.id
                });
              }

              // Get Height of newsletter dialog to properly size confirmation modal;
              const modalHeight = modalElement.offsetHeight;
              if (modalHeight > 0) {
                document.documentElement.style.setProperty('--newsletter-modal-height', `${modalHeight}px`);
              }

              // Close modal if confirmation appears
              modalElement.close();
              observer.disconnect();
            }
            else if (
              mutation.addedNodes.length > 0 &&
              modalElement.querySelector('div[data-drupal-messages]')
            ) {
              const form = modalElement.querySelector('form');
              const input = form.elements['email_address'];

              if (form && input && !form.checkValidity()) {
                dataLayer.push({
                  'data-analytics-event': 'form_error',
                  'data-analytics-form-error-name': form.id,
                  'data-analytics-form-error-type': input.validity.valueMissing ? 'valueMissing' : 'patternMismatch',
                  'data-analytics-form-error-message': input.validationMessage
                });
              }
            }
          });
        });

        observer.observe(modalElement, {
          childList: true,
          subtree: true
        });
      }
    }
  };
})(Drupal, once, window.dataLayer);
